import { useState, useCallback } from "react";
import { defineAbilityFor, User, AppAbility } from "../abilities";
import type { AbilityProviderProps } from "../types/types";
import { AbilityContext } from "./abilityContext";

export function AbilityProvider({ children, initialUser = null }: AbilityProviderProps) {
  const [user, setUser] = useState<User | null>(initialUser);
  const [ability, setAbility] = useState<AppAbility>(() => defineAbilityFor(user));

  const updateUser = useCallback((newUser: User | null) => {
    setUser(newUser);
    setAbility(defineAbilityFor(newUser));
  }, []);

  const contextValue = {
    ability,
    user,
    updateUser,
  };

  return <AbilityContext.Provider value={contextValue}>{children}</AbilityContext.Provider>;
}
